import { CdkPortalOutlet, PortalModule } from '@angular/cdk/portal';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PalantirTabComponent } from './components/tab/tab.component';
import { PalantirTabContentDirective } from './directives/content.directive';
import { PalantirStepLabel } from './directives/step-label.directive';
import { PalantirTabsComponent } from './tabs.component';

@NgModule({
  imports: [CommonModule, PortalModule, CdkPortalOutlet, CdkStepperModule],
  declarations: [
    PalantirTabContentDirective,
    PalantirStepLabel,
    PalantirTabsComponent,
    PalantirTabComponent,
  ],
  exports: [
    PalantirTabsComponent,
    PalantirTabComponent,
    PalantirTabContentDirective,
    PalantirStepLabel,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirTabsModule {}
